import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[620px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20artistic%20background%20with%20warm%20coral%20and%20cream%20gradient%2C%20soft%20geometric%20shapes%2C%20subtle%20comic%20panel%20line%20patterns%2C%20modern%20minimalist%20design%2C%20elegant%20atmosphere%2C%20no%20text%2C%20clean%20aesthetic%2C%20digital%20art%20style%2C%20gentle%20warm%20lighting%2C%20sophisticated%20composition&width=1600&height=700&seq=hero-bg-comics&orientation=landscape"
        alt="香香漫画 - 免费漫画在线阅读"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>
      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading text-background-50 mb-4 drop-shadow-lg animate-fade-in">
            香香漫画
          </h1>
          <p className="text-base md:text-xl text-background-200 mb-3 max-w-2xl mx-auto leading-relaxed drop-shadow-md">
            韩漫日漫国漫免费在线阅读，好看的漫画免费全集大全
          </p>
          <p className="text-sm md:text-base text-background-300 mb-8 max-w-xl mx-auto drop-shadow-md">
            下拉式追更体验，安全直达，追更不等待
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category"
              className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer hover:scale-105"
            >
              开始阅读
            </Link>
            <Link
              to="/category?type=韩漫"
              className="px-8 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 rounded-full font-medium text-base border border-background-50/30 hover:bg-background-50/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              热门韩漫
            </Link>
          </div>
          <div className="flex items-center justify-center gap-6 mt-10 text-background-200 text-sm">
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-fire-line text-accent-400 text-lg"></i>
              </div>
              <span>海量资源</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-arrow-down-line text-accent-400 text-lg"></i>
              </div>
              <span>下拉追更</span>
            </div>
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-shield-check-line text-accent-400 text-lg"></i>
              </div>
              <span>安全直达</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}